// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es6.array.fill.js
// module id = ZBH0
// module chunks = 1